// The Vue build version to load with the 'import' command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// plugins
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import vuetify from '@/plugins/vuetify'
import VueHead from 'vue-head'
import VeeValidate, { Validator } from 'vee-validate'
import itOriginalMessages from 'vee-validate/dist/locale/it'
import it from 'vee-validate/dist/locale/it.js'
import vue2Dropzone from 'vue2-dropzone'
import { VueEditor, Quill } from 'vue2-editor'
import VueSignaturePad from 'vue-signature-pad'
import { routerHistory, writeHistory } from 'vue-router-back-button'
import 'whatwg-fetch'

// Capacitor imports
import capacitorService from '@/services/capacitor-service'
import oneSignalService from '@/services/onesignal-service'

// globals
import AppTabs from '@/components/common/AppTabs'
import App from '@/App'

import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/dist/vuetify.css'
import '@/css/utility.css'
import '@/css/custom.css'
import '@/css/email-body.css'
import '@/css/capacitor-safe-areas.css'
import '@/assets/css/table-enhancements.css'

import './library/filters.js'
import './library/directives.js'
import './library/customRules'

import store from '@/store'
import router from '@/router'

import { trans } from '@/components/utilities/trans.js'
import { format } from 'date-fns'
import { eventBusUtility } from '@/eventBusUtility.js'
import { validateTaxCode, validateVatCode } from '@/components/utilities/validateTaxCode.js'
Vue.validateTaxCode = validateTaxCode
Vue.validateVatCode = validateVatCode
import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)
// common components
import Crud from '@/components/common/Crud'
import Show from '@/components/common/Show'
import InputFile from '@/components/common/InputFile'
import ImageInput from '@/components/common/ImageInput'
import DmsUploader from '@/components/common/DmsUploader'
import ConfirmDialog from '@/components/common/ConfirmDialog'
import ConfirmDialogV2 from '@/components/common/ConfirmDialogV2'
import FieldsGenerator from '@/components/common/FieldsGenerator'
import CreateDialogButton from '@/components/common/CreateDialogButton'
import AsyncAutocomplete from '@/components/common/AsyncAutocomplete'

import * as Sentry from "@sentry/vue";


// Passport
import PassportClients from '@/components/passport/Clients'
import PassportAuthorizedClients from '@/components/passport/AuthorizedClients'
import PassportPersonalAccessTokens from '@/components/passport/PersonalAccessTokens'

import QuillImageDropAndPaste from 'quill-image-drop-and-paste'
import ImageResize from 'quill-image-resize-module'
import MagicUrl from 'quill-magic-url'
import Mention from 'quill-mention'

Quill.register('modules/imageDropAndPaste', QuillImageDropAndPaste)
Quill.register('modules/imageResize', ImageResize)
Quill.register('modules/magicUrl', MagicUrl)
Quill.register('modules/Mention', Mention)

if(process.env.NODE_ENV === 'production') {

	Sentry.init({
		Vue,
		dsn: "https://7cf71d6e2c504beca4433177fe61a2d6@o81644.ingest.us.sentry.io/1373504",
		integrations: [
			Sentry.replayIntegration(
				{
					maskAllText: false,
					lockAllMedia: false,
				}
			),
		],
		// Session Replay
		replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
		replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
	})
}


window._ = require('lodash')
window.moment = require('moment')
window.moment.locale('it')

window.Pusher = require('pusher-js')

Vue.use(Vuex)
Vue.use(VueAxios, axios)

Validator.localize('it', it)

let version = 5
let minor = 23

if(localStorage.version && localStorage.version < version) {
	// Save the keys that should be preserved
	const preservedKeys = ['fqdn', 'user', 'user-token'];
	const preservedValues = {};
	
	preservedKeys.forEach(key => {
		if(localStorage.getItem(key)) {
			preservedValues[key] = localStorage.getItem(key);
		}
	});
	
	// Clear localStorage
	localStorage.clear();
	
	// Restore preserved keys
	Object.keys(preservedValues).forEach(key => {
		localStorage.setItem(key, preservedValues[key]);
	});
}

localStorage.version = version

if(localStorage.minor && localStorage.minor < minor) {
	window.location.href = window.location.origin
		+ window.location.pathname
		+ '?v=' + Date.now()
		+ window.location.hash
}

localStorage.minor = minor

// Pulisce il flag di ack se il nuovo bundle è stato caricato
if (localStorage.minor_ack && parseInt(localStorage.minor_ack) < minor) {
	localStorage.removeItem('minor_ack')
}

// Controllo periodico per nuove versioni (ogni 5 minuti) - solo su web, non su app mobile
if (!capacitorService.isNative) {
	function checkForUpdates() {
		fetch('./version.json?t=' + Date.now())
			.then(res => res.json())
			.then(data => {
				const acked = parseInt(localStorage.minor_ack) || 0
				if (data.minor > minor && data.minor > acked) {
					store.commit('setUpdateAvailable', true)
				}
			})
			.catch(() => {})
	}

	// Avvia il controllo periodico dopo 1 minuto, poi ogni 5 minuti
	setTimeout(() => {
		checkForUpdates()
		setInterval(checkForUpdates, 5 * 60 * 1000)
	}, 60 * 1000)
}

Vue.use(routerHistory)

Vue.config.productionTip = true
Vue.use(VueHead)

// Rendi i servizi Capacitor disponibili globalmente
Vue.prototype.$capacitor = capacitorService
Vue.prototype.$oneSignal = oneSignalService

Vue.component('vue-dropzone', vue2Dropzone)
Vue.component('vue-editor', VueEditor)
Vue.use(VueSignaturePad)

import TinymceEditor from '@/components/common/TinymceEditor.vue'
Vue.component('tinymce-editor', TinymceEditor)

import GMHDatePicker from '@/components/common/GMHDatePicker.vue'
Vue.component('gmh-date-picker', GMHDatePicker)

// register common components
Vue.component('show', Show)
Vue.component('crud', Crud)
Vue.component('app-tabs', AppTabs)
Vue.component('input-file', InputFile)
Vue.component('image-input', ImageInput)
Vue.component('dms-uploader', DmsUploader)
Vue.component('confirm-dialog', ConfirmDialog)
Vue.component('confirm-dialog-v-2', ConfirmDialogV2)
Vue.component('fields-generator', FieldsGenerator)
Vue.component('create-dialog-button', CreateDialogButton)
Vue.component('async-autocomplete', AsyncAutocomplete)

// Passport
Vue.component('passport-clients', PassportClients);
Vue.component('passport-authorized-clients', PassportAuthorizedClients);
Vue.component('passport-personal-access-tokens', PassportPersonalAccessTokens);

// Capacitor gestisce automaticamente l'iniezione del runtime nativo
// Non è necessario aggiungere script manualmente come con Cordova

store.dispatch('SET_FQDN')

Vue.axios.defaults.headers = {
	'Content-Type': 'application/json',
	'Accept': 'application/json',
	'X-Requested-With': 'XMLHttpRequest',
	Authorization: 'Bearer ' + localStorage.getItem('user-token')
}
Vue.axios.defaults.withCredentials = true

// Le tab si tengono allineate sul token: un login in una tab fa entrare
// anche le altre, un logout in una tab fa uscire anche le altre. L'evento
// 'storage' arriva solo alle ALTRE tab, mai a chi ha scritto.
window.addEventListener('storage', (evento) => {
	if (evento.key !== 'user-token') return
	const nuovo = evento.newValue
	const attuale = store.getters.token
	if (nuovo && nuovo !== attuale) {
		store.commit('AUTH_ADOPT_TOKEN', nuovo)
		store.dispatch('USER_REQUEST').then(() => {
			if (router.currentRoute && router.currentRoute.name === 'login') {
				router.push('/').catch(() => {})
			}
		}).catch(() => {})
	} else if (!nuovo && attuale) {
		store.commit('AUTH_LOGOUT')
	}
})

router.beforeEach((to, from, next) => {
	store.commit('startProgress')
	next()
})

router.afterEach(writeHistory)

// Traccia la navigazione per il trail dei breadcrumb (vedi store/modules/navigation.js)
router.afterEach((to, from) => store.dispatch('TRACK_NAVIGATION', { to, from, router }))

// Request interceptor - aggiunge bypass token se presente e non scaduto
Vue.axios.interceptors.request.use((config) => {
	const bypassDataStr = localStorage.getItem('maintenance_bypass')
	if (bypassDataStr) {
		try {
			const bypassData = JSON.parse(bypassDataStr)
			if (bypassData.expiry && Date.now() < bypassData.expiry) {
				config.headers['X-Maintenance-Bypass'] = bypassData.token
			} else {
				// Token scaduto, rimuovilo
				localStorage.removeItem('maintenance_bypass')
			}
		} catch (e) {
			// Formato vecchio (stringa semplice), rimuovilo
			localStorage.removeItem('maintenance_bypass')
		}
	}
	return config
})

// Add a response interceptor
Vue.axios.interceptors.response.use((response) => {
	store.commit('goOnline')
	return response
},
error => {
	if (error.message == 'Network Error') {
		store.commit('goOffline')
	} else if (error.config && error.config.silent) {
		// Richiesta di servizio (es. diagnostica della barra operatore): il
		// suo esito non riguarda l'utente, niente avvisi ne' redirect
	} else if (error.config && error.config.silentClientErrors && error.response && error.response.status < 500) {
		// Errori che il componente mostra da se' (es. login dell'Area Clienti).
		// Quelli del server proseguono: manutenzione, avviso e Sentry
	} else if (error.response.status == 503) {
		if (error.response.data && error.response.data.status === 'maintenance') {
			store.commit('setMaintenanceMode', {
				active: true,
				message: error.response.data.message || 'Sistema in manutenzione'
			})
			store.commit('setSnackbar', {
				timeout: 6000,
				text: error.response.data.message || 'Sistema in manutenzione',
				value: true,
				color: 'warning'
			})
			store.commit('endProgress')
		}
	} else if (error.response.status == 404) {
		const currentRoute = router.currentRoute
		if (currentRoute.meta && currentRoute.meta.portal) {
			// Area portale: la gestione del 404 è lasciata ai componenti
			// (nessun redirect fuori dal portale, nessuna rotta "*-index").
			store.commit('endProgress')
		} else if (currentRoute.params && currentRoute.params.id) {
			const routeParts = (currentRoute.name || '').split('-')
			if (routeParts.length > 1) {
				const fallbackRedirect = () => {
					store.commit('setSnackbar', {
						timeout: 6000,
						text: 'Il record non è più disponibile. Potrebbe essere stato convertito o eliminato da un\'automazione.',
						value: true,
						color: 'warning'
					})
					store.commit('endProgress')
					router.push({ name: routeParts[0] + '-index' }).catch(() => {})
				}
				// Lead non trovato: se è stato convertito in prospect da un'automazione
				// e l'utente ha i permessi, reindirizza alla nuova scheda invece che alla lista.
				// La guardia sull'URL evita ricorsione se l'endpoint stesso risponde 404.
				if (routeParts[0] === 'leads' && !(error.config && error.config.url && error.config.url.includes('leads-converted-prospect'))) {
					// NB: onRejected come secondo argomento di then, NON .catch():
					// il reject finale (per i .catch dei componenti) non deve
					// essere re-intercettato qui annullando il redirect.
					return Vue.axios.get('leads-converted-prospect/' + currentRoute.params.id)
						.then(({ data }) => {
							if (data.converted && data.can_view_prospect) {
								store.commit('setSnackbar', {
									timeout: 8000,
									text: 'Il lead è stato convertito in contatto da un\'automazione: sei stato reindirizzato alla nuova scheda.',
									value: true,
									color: 'info'
								})
								store.commit('endProgress')
								router.push({ name: 'prospects-show', params: { id: data.prospect_id } }).catch(() => {})
							} else {
								fallbackRedirect()
							}
						}, () => {
							// Errore della chiamata di verifica (es. backend senza endpoint)
							fallbackRedirect()
						})
						.then(() => Promise.reject(error))
				}
				fallbackRedirect()
			} else {
				router.push({name: 'notfound'})
			}
		} else {
			router.push({name: 'notfound'})
		}
	} else if (error.response.status == 403) {
		// Se il backend segnala cambio password obbligatorio per utente portale
		if (error.response.data && error.response.data.force_password_change
			&& router.currentRoute && router.currentRoute.meta && router.currentRoute.meta.portal) {
			store.commit('PORTAL_SET_FORCE_PASSWORD')
			router.push('/portal/change-password').catch(() => {})
		} else {
			store.commit('setSnackbar', {
				timeout: 6000,
				text: error.response.data.message ? error.response.data.message : 'Permesso negato',
				value: true,
				color: 'warning'
			})
		}
		store.commit('endProgress')

	} else if (error.response.status == 401) {
		// Un 401 vale come "sessione finita" solo se la richiesta portava il
		// token della sessione corrente. Una richiesta partita senza token (tab
		// gia' sloggata) o con un token vecchio non dice nulla sulla sessione
		// attiva, e sloggare qui cancellerebbe il token di un'altra tab.
		const inviato = error.config && error.config.headers ? error.config.headers.Authorization : null
		const corrente = store.getters.token ? 'Bearer ' + store.getters.token : null
		const dellaSessioneCorrente = !!corrente && inviato === corrente
		const inAreaPortale = !!(router.currentRoute && router.currentRoute.meta && router.currentRoute.meta.portal)
		// Non fare logout/redirect se siamo in area portale (i componenti gestiscono i propri errori)
		if (dellaSessioneCorrente && !inAreaPortale) {
			store.commit('setSnackbar', {
				timeout: 6000,
				text: error.response.data.message ? error.response.data.message : 'Non autenticato',
				value: true,
				color: 'warning'
			})
			store.commit('AUTH_LOGOUT')
		}
		// Area portale: un 401 sul token portale corrente vuol dire che il server
		// ha chiuso la sessione (attivazione della 2FA obbligatoria, Reset 2FA).
		// Senza uscire il portale resterebbe vuoto finche' l'utente non esce a mano.
		const portaleCorrente = store.state.portal && store.state.portal.token ? 'Bearer ' + store.state.portal.token : null
		if (inAreaPortale && !!portaleCorrente && inviato === portaleCorrente) {
			// localStorage e' condiviso fra le tab: se un'altra tab ha gia' aperto
			// una sessione nuova, questa tab la adotta ricaricandosi invece di
			// cancellarla col logout
			const tokenSalvato = localStorage.getItem('portal-token')
			if (tokenSalvato && tokenSalvato !== store.state.portal.token) {
				window.location.reload()
			} else {
				store.commit('PORTAL_SET_SESSION_EXPIRED')
				store.commit('PORTAL_LOGOUT')
			}
		}
	} else if (error.response.status == 422 && error.config && error.config.silentValidation) {
		// Richiesta che mostra da se' gli errori di validazione (es. anteprime
		// calcolate mentre l'utente compila un modulo): niente snackbar
	} else if (error.response.status == 422) {
		// Errore di validazione: mostra il primo messaggio reale (data.errors),
		// non il generico "The given data was invalid." — niente Sentry, è input utente
		let validationText = error.response.data.message ? error.response.data.message : 'Dati non validi'
		if (error.response.data.errors) {
			const firstField = Object.values(error.response.data.errors)[0]
			if (Array.isArray(firstField) && firstField.length) {
				validationText = firstField[0]
			}
		}
		store.commit('setSnackbar', {
			timeout: 6000,
			text: validationText,
			value: true,
			color: 'warning'
		})
	} else {
		store.commit('setSnackbar', {
			timeout: 6000,
			text: error.response.data.message ? error.response.data.message : 'Ops.. Qualcosa è andato storto',
			value: true,
			color: 'error'
		})
		const customError = new Error('Errore su API ' + error.request.responseURL)
		customError.name = 'Backend Error'
		customError.extra = { custom: error }
		Sentry.captureException(customError)
	}
	return Promise.reject(error)
})

Vue.prototype.$eventBusUtility = eventBusUtility
Vue.prototype.$trans = trans
Vue.prototype.$format = format
Vue.trans = trans

/* eslint-disable no-new */
var app = new Vue({
	el: '#app',
	store,
	router,
	axios,
	vuetify,
	template: '<App/>',
	components: { App, AppTabs },
	head: {
		meta: [
			{
				name: 'viewport',
				content:
				'width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover'
			}
		]
	},
})

document.title =  'GiveMeHive!'

window.handleOpenURL = url => {
	router.replace(url.replace('yello://', ''))
}

window.onbeforeunload = function(){
	if(store.getters.modelEdited)
		return 'Le modifiche apportate potrebbero non essere salvate.'
};